import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultDatalabelsAlign,
  defaultDatalabelsAnchor,
  defaultDatalabelsFontWeight,
  defaultTicksCustomValue,
} from "../../../utils";

const EvolutionTauxMobilite = {
  checked: false,
  titleSideBar: "Evolution du taux de mobilité",
  titleIndicator: "SUMP Trajectory Content.charts.EvolutionTauxMobilite.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["evolutionTauxMobilite"],
  },
  keyFigure: {
    typeUpdate: "geographical_area", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "bar",
      typeLabels: "years", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "false",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "300",
      widthChart: "500",
      i18nKeyLabels:
        "SUMP Trajectory Content.charts.EvolutionTauxMobilite.axis.labelsX",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: true,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: true,
          titleDisplay: true,
          titleText: [
            "SUMP Trajectory Content.charts.EvolutionTauxMobilite.axis.titleY1",
            "SUMP Trajectory Content.charts.EvolutionTauxMobilite.axis.titleY2",
          ],
          gridDisplay: true,
          beginAtZero: true,
          max: 5,
          ticks: {
            display: true,
            value: {
              prefix: "",
              suffix: "",
            },
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: undefined,
        annotation2: undefined,
      },
      keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EvolutionTauxMobilite.legend.HIDETOOLTIPIFZERODéplacements",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=evolution_taux_mobilite&trend=projection&chart=evolution_taux_mobilite&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_evolution_taux_mobilite"]
              .backgroundColor["0"],
          borderColor:
            configChartsColorPalettes["trajectory_evolution_taux_mobilite"]
              .borderColor["0"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.EvolutionTauxMobilite.legend.HIDELEGENDHIDETOOLTIPIFZERODéplacements",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=evolution_taux_mobilite&trend=projection&chart=evolution_taux_mobilite_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_evolution_taux_mobilite_objective_transparency"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_evolution_taux_mobilite_objective_transparency"
            ].borderColor["0"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
      ],
    },
  ],
};

export default EvolutionTauxMobilite;
